import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CategoryFileFragmentDoc } from '../../fragment/generated/CategoryFile';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCategoryMutationVariables = Types.Exact<{
  data: Types.UpdateFileInput;
}>;


export type UpdateCategoryMutation = { updateFile?: { file?: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } | null } | null };


export const UpdateCategoryDocument = /*#__PURE__*/ gql`
    mutation UpdateCategory($data: UpdateFileInput!) {
  updateFile(data: $data) {
    file {
      ...CategoryFile
    }
  }
}
    ${CategoryFileFragmentDoc}`;

export function useUpdateCategoryMutation() {
  return Urql.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument);
};